import axiosInstance from '../apiService';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = 'Connection/';

const getConnections = async (connectionTypeId) => axiosInstance.get(`${ENDPOINTORIGIN}GetConnections?connectionTypeId=${connectionTypeId}`, constants.REQUIRE_INTERCEPTORS);

const getConnectionById = async (connectionId) => axiosInstance.get(`${ENDPOINTORIGIN}GetConnectionById?connectionId=${connectionId}`, constants.REQUIRE_INTERCEPTORS);

const createConnection = async (model) => axiosInstance.post(`${ENDPOINTORIGIN}CreateConnection`, model, constants.REQUIRE_INTERCEPTORS);

const updateConnection = async (model) => axiosInstance.put(`${ENDPOINTORIGIN}UpdateConnection`, model, constants.REQUIRE_INTERCEPTORS);

const deleteConnection = async (id) => axiosInstance.delete(`${ENDPOINTORIGIN}DeleteConnection?id=${id}`, constants.REQUIRE_INTERCEPTORS);

export {
  getConnections,
  getConnectionById,
  createConnection,
  updateConnection,
  deleteConnection,
};